//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  applySnapshot,
  cast,
  getEnv,
  getSnapshot,
  types,
} from "mobx-state-tree";

export const emptyAvailability = {
  Monday: [],
  Tuesday: [],
  Wednesday: [],
  Thursday: [],
  Friday: [],
  Saturday: [],
  Sunday: [],
};

export const Availability = types.model("Availability", {
  Monday: types.optional(types.array(types.string), []),
  Tuesday: types.optional(types.array(types.string), []),
  Wednesday: types.optional(types.array(types.string), []),
  Thursday: types.optional(types.array(types.string), []),
  Friday: types.optional(types.array(types.string), []),
  Saturday: types.optional(types.array(types.string), []),
  Sunday: types.optional(types.array(types.string), []),
});

const AvailabilityStatus = types.model("AvailabilityStatus", {
  isAvailable: types.optional(types.boolean, true),
  resumptionDate: types.optional(types.string, ""),
  job_id: types.optional(types.string, ""),
});

export const ScheduleStore = types
  .model("ScheduleStore", {
    availability: types.optional(Availability, emptyAvailability),
    maxHours: types.optional(types.number, 0),
    maxDays: types.optional(types.number, 0),
    maxStudents: types.optional(types.number, 0),
    preferredLessonType: types.optional(types.array(types.string), [
      "physical",
    ]),
    availabilityStatus: types.optional(AvailabilityStatus, {}),
    lastCalendarUpdate: types.optional(types.string, ""),
    exemptedAreas: types.optional(types.array(types.string), []),
    loading: types.optional(types.boolean, false),
  })
  .views((self) => {
    return {
      get initialFormValues() {
        return {
          maxDays: self.maxDays,
          maxHours: self.maxHours,
          maxStudents: self.maxStudents,
          Friday: getSnapshot(self.availability).Friday,
          Monday: getSnapshot(self.availability).Monday,
          Sunday: getSnapshot(self.availability).Sunday,
          Tuesday: getSnapshot(self.availability).Tuesday,
          Saturday: getSnapshot(self.availability).Saturday,
          Thursday: getSnapshot(self.availability).Thursday,
          Wednesday: getSnapshot(self.availability).Wednesday,
        };
      },
      get formValues(): {
        maxDays: number;
        maxHours: number;
        maxStudents: number;
        availability?: {
          Friday: Array<string>;
          Monday: Array<string>;
          Sunday: Array<string>;
          Tuesday: Array<string>;
          Saturday: Array<string>;
          Thursday: Array<string>;
          Wednesday: Array<string>;
        };
      } {
        return getSnapshot(self);
      },
      get rawAvailablity() {
        return getSnapshot(self.availability);
      },
      get lessonTypes() {
        const lessonTypes: Array<"physical" | "online"> = [
          "physical",
          "online",
        ];
        return lessonTypes;
      },
      get possibleDays() {
        let values = getSnapshot(self.availability);
        const result = Object.values(values)
          .filter((x) => x.length > 0)
          .map((i, j) => j + 1);
        return result;
      },
      get completed() {
        let tutorSchedule = Object.values(self.availability).some(
          (x) => x.length > 0,
        );

        return (
          tutorSchedule && self.maxDays && self.maxHours && self.maxStudents
        );
      },
      // get formValues() {
      //   return getSnapshot(self);
      // },

      get lastUpdatedTime() {
        if (self.lastCalendarUpdate) {
          const today: any = new Date();
          const lastUpdate: any = new Date(self.lastCalendarUpdate);
          const oneDayTimeMs = 1000 * 60 * 60 * 24;
          const dateDifference = Math.round(
            (today - lastUpdate) / oneDayTimeMs,
          );
          return dateDifference;
        }
        return 0;
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);

    const setResumptionDate = (date) => {
      self.availabilityStatus.resumptionDate = date;
    };

    const setLastCalendarUpdate = () => {
      const currentTime = new Date(Date.now());
      self.lastCalendarUpdate = currentTime.toISOString();
    };

    // const updateTutorSchedule = flow(function* updateTutorSchedule(key) {
    //   try {
    //     if (key === "availabilityStatus") {
    //       if (self.availabilityStatus.isAvailable) {
    //         setResumptionDate("");
    //       }
    //     }
    //     const response = yield adapter.updateTutorSchedule(key, {
    //       ...getSnapshot(self),
    //       locationInfo: getSnapshot(self.rootStore.locationInfo),
    //       lastCalendarUpdate: new Date(Date.now()).toISOString(),
    //     });
    //     if (response) {
    //       setLastCalendarUpdate();
    //     }
    //     return response;
    //   } catch (error) {
    //     self.loading = false;
    //     throw error;
    //   }
    // });
    return {
      // updateTutorSchedule,
      setResumptionDate,
      saveData(values: any) {
        let { maxHours, maxStudents, maxDays, availability } = values;
        applySnapshot(self, {
          ...getSnapshot(self),
          maxHours,
          maxDays,
          maxStudents,
          availability,
        });
      },
      setAvailability(day, times) {
        let previous = getSnapshot(self.availability);
        let newAvailability = { ...previous, [day]: times };
        applySnapshot(self.availability, newAvailability);
        // self.availability = newAvailability;
      },
      setMaxHours(hours) {
        self.maxHours = hours;
      },
      setMaxDays(days) {
        self.maxDays = days;
      },
      setMaxStudents(students) {
        self.maxStudents = students;
      },
      setPreferredLessonType(values) {
        self.preferredLessonType = cast(values);
      },
      toggleTutorAvailability() {
        self.availabilityStatus.isAvailable =
          !self.availabilityStatus.isAvailable;
      },
      updateFields(values) {
        const oldValues = getSnapshot(self);
        applySnapshot(self, { ...oldValues, ...values });
      },

      // setExemptedAreas(locations) {
      //   const regionOptions = [...self.rootStore.locationInfo.regionOptions];
      //   const locationInState = locations.map((location) => {
      //     if (regionOptions.includes(location)) {
      //       return location;
      //     } else {
      //       return undefined;
      //     }
      //   });
      //   const stateLocation = locationInState.filter((loc) => {
      //     if (loc) {
      //       return loc;
      //     }
      //   });
      //   self.exemptedAreas = cast(stateLocation);
      // },
    };
  });

export default ScheduleStore;
